<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody reportCards newsDetailMargin">
          <div class="reportAllDetailClass">
              <div class="forTopHeight"></div>
              <div class="htmlBoldTitle">{{this.title}}<div class="htmlcommenTime">{{reporterVal}}</div></div>
              <div class="forLine"></div>
              <div class="markdown-body" v-html="this.content"></div>              
          </div>
          <div style="display:flex;justify-content:center;margin-top:5px;">
            <Button class="reportBtn ql-editor" @click="downLoadFN">{{$t('downLoad')}}</Button>
          </div>
      </div>
        <Modal
            :footer-hide='true'
            v-model="confirmModal"
            :title="$t('hellow')">
            <div class="registTitle">
                {{$t('confirmMsg')}}
            </div>
            <div class="inputInClass">
                <Input prefix="md-mail" v-model="mailModel" :placeholder="$t('mailVal')"  />
            </div>
            <div class="inputInClass">
                <Input prefix="md-person" v-model="peoModel" :placeholder="$t('userVal')"  />
            </div>
            <div class="inputInClass">
                <Button @click="confirmFN">{{$t('confirmBtn')}}</Button>
            </div>
        </Modal>
      <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { reportListDetailRequest, reportDownloadRequest, reportLinkRequest } from '../request/request'
export default {
  name: 'home',
  components: {
    headerShow, footerView
  },
  data () {
    return {
      reporterVal: '',
      fileName: '',
      mailModel: '',
      peoModel: '',
      companyModel: '',
      postModel: '',
      confirmModal: false,
      languageVal: 'ch',
      id: '',
      title: '',
      content: '',
      type: 0
    }
  },
  computed: {
  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  watch: {
    '$route' (to, from) {
      this.initFN()
    }
  },
  methods: {
    async reportListDetailRequestFN (e) {
      var res = await reportListDetailRequest(e)
      if (res.data.code === 0) {
        this.title = res.data.data.title
        // res.data.data.publishDate.substring(0, 10)
        // this.reporterVal = res.data.data.announcer ? res.data.data.announcer : '' + ' ' + res.data.data.createTime
        this.fileName = res.data.data.file
        this.type = res.data.data.type
        this.content = res.data.data.brief
        var time = res.data.data.publishDate ? res.data.data.publishDate.substring(0, 10) : ''
        var name = res.data.data.announcer ? res.data.data.announcer : ''
        this.reporterVal = name + ' ' + time
      }
    },
    async reportDownloadRequestFN (e) {
      var res = await reportDownloadRequest(e)
      if (res.data.code === 0) {
        this.confirmModal = false
        this.$Message.success('请耐心等待客服联系')
      } else {
        this.$Message.success('请先登录')
      }
    },
    async reportLinkRequestFN (e) {
      var res = await reportLinkRequest(e)
      if (res.data.code === 0) {
        var list = res.data.data.list
        var showMark = 0
        list.forEach(element => {
          if (element.status === 1) { showMark = 1 }
        })
        if (showMark === 0) {
          this.confirmModal = true
        } else {
          window.open(this.$staticUrl + '/admin/smg/file/getFile?name=' + this.fileName)
        }
      } else {
        // this.$Message.success('请先登录')
      }
    },
    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },
    initFN () {
      this.id = this.$route.query.id
      this.reportListDetailRequestFN({ id: this.id, lang: this.languageVal })
    },
    confirmFN () {
      this.reportDownloadRequestFN({ reportId: this.id, status: 0, userId: localStorage.userVal, contactMobile: this.mailModel, contactName: this.peoModel })
    },
    downLoadFN () {
      if (this.type === 2) {
        window.open(this.fileName)
        // this.reportLinkRequestFN({ reportId: this.id, userId: '' })
      } else {
        if (localStorage.userVal) {
          this.mailModel = localStorage.contact
          this.peoModel = localStorage.userName
          this.reportLinkRequestFN({ reportId: this.id, userId: localStorage.userVal })
        } else {
          this.$Message.success('请先注册或登录')
        }
      }

    //   this.confirmModal = true
      //         localStorage.contact = this.phoneModel
      // localStorage.userName = this.peoModel
    //   this.reportDownloadRequestFN({ reportId: this.id, status: 0, userId: localStorage.userVal })
    //   this.$Message.success('你点击了支付下载按钮')
    }
  }
}
</script>
<style lang="scss">
.cardContent{
    width: 100%;
    height: 20vh;
    @include centerLine
}
.cardImg{
    @include containbackground;
    width: 30%;
    height:100%;
    // background-position-y: 0;
    // background-image:  url('../assets/3.png');
}
.cardTxt{
    width: 60%;
    height:100%
}
.cardTitle{
    color:#40A0F0
}
.reportAllDetailClass{

}
.reportBtn{
    background:linear-gradient(90deg,rgba(64,160,240,1) 0%,rgba(122,189,245,1) 100%);
    color:white;
}
</style>
